<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryCountResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable"  :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        :disabled="actionDisabled('selectOne')"
                                        @click="openFeedBack()"
                                    >
                                        审核反馈
                                    </b-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="审核反馈" :visible.sync="feedbackDialogVisible" :close-on-click-modal='false' append-to-body @close='clearFeedbackForm'>
            <el-form :model="feedbackForm" ref="feedbackForm" label-width="auto">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="反馈意见">
                            <el-input v-model="feedbackForm.reasons" type="textarea"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div slot="footer">
                <el-button @click="feedbackDialogVisible = false">取消</el-button>
                <el-button @click="confirmFeedback()" type="primary">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    // Author Lin
    // Date 2021-08-11 17:38:18

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCommonApiMixin from "@/mixin/em/common/api";
    import commonViewsUtil from "@/utils/commonViewsUtil";
    import emCustomVuexMixin from "@/mixin/em/customVuex";

    export default {
        name: "sithMesInventoryCountListView",
        mixins: [emCommonListMixin, emCommonApiMixin, emCustomVuexMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                feedbackDialogVisible: false,
                feedbackForm: {
                    reasons: ''
                }
            }
        },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            },
            checkedItems() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItems"];
            },
            selectIds() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItems"].join(",");
            },
        },
        mounted() {
            if (this.$route.query.countId) {
                this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.countId);
                this.$refs.doQuery();
            }
        },
        methods: {
            actionDisabled(type) {
                    // 删除按钮在一条记录都没选的时候禁用
                if (type === "select") {
                        return this.checkedItems && this.checkedItems.length === 0;
                }
                    // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
                else if (type === "selectOne") {
                    return this.checkedItems && this.checkedItems.length !== 1;
                }
            },
            openFeedBack() {
                this.feedbackDialogVisible = true;
            },
            clearFeedbackForm() {
                this.feedbackForm.reasons = ''
            },
            confirmFeedback() {
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/confirmFeedback?ids=${self.selectIds}`
                self.$_emApiMixin_post(url, self.feedbackForm)
                .then(response => {
                    commonViewsUtil.showSuccess(self, "已反馈");
                    self.$refs.emListFilter.doQuery()
                })
                .finally(() => self.feedbackDialogVisible = false)
            }
        }
    };
</script>
